<template>
  <div>
    <Header />
    <Nav />
    <div class="body pb70">
      <div class="menu bgc"></div>
      <div class="container">
        <div class="newsBox">
          <div class="top">
            <div class="title">新闻中心</div>
            <div class="subTitle">News Center</div>
          </div>
          <div class="content">
            <div class="siderBar">
              <div
                :class="`${$route.query.type === '0' ? 'active' : ''}`"
                @click="$router.push('/news/list?type=0')"
              >
                新闻资讯
              </div>
              <div
                :class="`${$route.query.type === '1' ? 'active' : ''}`"
                @click="$router.push('/news/list?type=1')"
              >
                平台公告
              </div>
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../../components/Footer.vue";
import Header from "../../components/Header.vue";
import Nav from "../../components/Nav.vue";

export default {
  components: { Header, Footer, Nav }
};
</script>

<style scoped lang="scss">
.body {
  padding-bottom: 70px;
  display: inline-block;
  width: 100%;
  background-color: #f0f2f5;
  .newsBox {
    padding: 60px;
    margin: 40px 0 0px 0;
    line-height: 30px;
    background: #fff;
    font-size: 14px;
    color: #6e6e6e;
    .top {
      border-bottom: 3px solid #f0f2f5;
      margin-bottom: 50px;
      .title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #393939;
        // line-height: 41px;
      }
      .subTitle {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a2a2a2;
        // line-height: 41px;
        margin-bottom: 20px;
      }
    }
    .content {
      display: flex;
      .siderBar {
        width: 191px;
        display: inline-block;
        div {
          margin-bottom: 48px;
          padding-left: 10px;
          height: 16px;
          align-items: center;
          display: flex;
          cursor: pointer;
          border-left: 3px solid #fff;
          color: #A2A2A2;
        }
        .active {
          // border-left: 3px solid #3A61B1;
          color: #393939;
          border-left: 3px solid #3a61b1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue